import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const SPECIFICCONSUMPTIONTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SpecificConsumptionType.Name')
    .required()
    .minLength(1)
    .maxLength(200)
    .build(),
  FieldBuilder
    .text('code', 'Entity.SpecificConsumptionType.Code')
    .required()
    .minLength(1)
    .maxLength(6)
    .build(),
];

export const SPECIFICCONSUMPTIONTYPE_CONFIG = {
  entityName: 'SpecificConsumptionType',
  localizationKey: 'Planning::Entity.SpecificConsumptionType',
  fields: SPECIFICCONSUMPTIONTYPE_FIELDS,
  permission: 'ResearchAndDevelopmentGeneticMaterial.SpecificConsumptionTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.GeneticMaterial + MENU_NAME_SUFFIX,
};
